/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {
  AssetUploadResponse,
  DeleteAssetsRequest,
  DeleteAssetsResponse,
  ListBackgroundsParams,
  PredefinedBackgroundsResponse,
  UploadBody,
  UploadParams,
} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Upload an image asset (background, screenshot or decal). Max 5 MB, JPEG/PNG/WebP only.
 */
export type uploadResponse200 = {
  data: AssetUploadResponse
  status: 200
}

export type uploadResponseSuccess = uploadResponse200 & {
  headers: Headers
}
export type uploadResponse = uploadResponseSuccess

export const getUploadUrl = (params?: UploadParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : String(v)))
      } else {
        normalizedParams.append(key, value === null ? 'null' : value.toString())
      }
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/assets/upload?${stringifiedParams}` : `/assets/upload`
}

export const upload = async (
  uploadBody: UploadBody,
  params?: UploadParams,
  options?: RequestInit,
): Promise<uploadResponse> => {
  const formData = new FormData()
  formData.append(`file`, uploadBody.file)

  return customFetch<uploadResponse>(getUploadUrl(params), {
    ...options,
    method: 'POST',
    body: formData,
  })
}

/**
 * Delete user-uploaded assets (e.g. an image replaced in the editor). Only the caller's
own objects are removed; foreign or predefined keys are ignored.
 */
export type deleteAssetsResponse200 = {
  data: DeleteAssetsResponse
  status: 200
}

export type deleteAssetsResponseSuccess = deleteAssetsResponse200 & {
  headers: Headers
}
export type deleteAssetsResponse = deleteAssetsResponseSuccess

export const getDeleteAssetsUrl = () => {
  return `/assets`
}

export const deleteAssets = async (
  deleteAssetsRequest: DeleteAssetsRequest,
  options?: RequestInit,
): Promise<deleteAssetsResponse> => {
  return customFetch<deleteAssetsResponse>(getDeleteAssetsUrl(), {
    ...options,
    method: 'DELETE',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(deleteAssetsRequest),
  })
}

/**
 * List predefined background images with pagination.
 */
export type listBackgroundsResponse200 = {
  data: PredefinedBackgroundsResponse
  status: 200
}

export type listBackgroundsResponseSuccess = listBackgroundsResponse200 & {
  headers: Headers
}
export type listBackgroundsResponse = listBackgroundsResponseSuccess

export const getListBackgroundsUrl = (params?: ListBackgroundsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : String(v)))
      } else {
        normalizedParams.append(key, value === null ? 'null' : value.toString())
      }
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/assets/backgrounds?${stringifiedParams}` : `/assets/backgrounds`
}

export const listBackgrounds = async (
  params?: ListBackgroundsParams,
  options?: RequestInit,
): Promise<listBackgroundsResponse> => {
  return customFetch<listBackgroundsResponse>(getListBackgroundsUrl(params), {
    ...options,
    method: 'GET',
  })
}
